import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { VerticalSpace } from '@/components'
import * as types from '../../../store/types'
import * as events from '../../../event-types'
import { createEventBus } from '@appbase/util'
import api from '../../../api/hr'
import * as accountTypes from '@account/store/types';


@Component({
	components: { VerticalSpace },
	directives: {
		focus: {
			// When the bound element is inserted into the DOM...
			inserted: function (el) {
				// Focus the element
				el.focus()
			},
		},
	},
	computed: {
		...mapGetters({
			viewMode: types.RECIPIENT_VIEW_MODE,
			searchResults: types.RECIPIENT_SEARCH,
			lastSearchKeyword: types.RECIPIENT_SEARCH_KEYWORD,
			currentUser: accountTypes.USER,
		}),
	},
	methods: {
		...mapActions({
			beginSearch: types.RECIPIENT_SEARCH,
			cancelSearch: types.RECIPIENT_SEARCH_CANCEL, 
		}),
		...mapMutations({
			changeViewMode: types.RECIPIENT_VIEW_MODE,
			changeComCode: types.RECIPIENT_COMPANY_CHANGE
		}),
	},
})
export default class SearchBar extends Vue {
	//
	// ────────────────────────────────────────────────────────── I ──────────
	//   :::::: M U T A T I O N S : :  :   :    :     :        :          :
	// ────────────────────────────────────────────────────────────────────
	//
	changeViewMode!: (mode: recipient.ViewMode) => void

	//
	// ────────────────────────────────────────────────────── I ──────────
	//   :::::: A C T I O N S : :  :   :    :     :        :          :
	// ────────────────────────────────────────────────────────────────
	//

	beginSearch!: (keyword: string) => Promise<void>
	cancelSearch!: () => Promise<void>
	changeComCode!: (comCode: string) => Promise<void>


	//
	// ────────────────────────────────────────────────────── I ──────────
	//   :::::: G E T T E R S : :  :   :    :     :        :          :
	// ────────────────────────────────────────────────────────────────
	//

//	getCompanies!: recipient.Company[];

	viewMode!: recipient.ViewMode
	searchResults!: recipient.PagedItemList<recipient.OrgPerson> | null
	lastSearchKeyword!: string
	companies: recipient.Company[] = [];
	currentUser!: account.User;
	currentComcode: string = '';
	//
	// ──────────────────────────────────────────────────────── I ──────────
	//   :::::: C O M P U T E D : :  :   :    :     :        :          :
	// ──────────────────────────────────────────────────────────────────
	//

	get totalCount() {
		return this.searchResults ? this.searchResults.totalCount : 0
	}

	get description() {
		return this.$t('큐브룩_검색결과', {
			resultCount: this.totalCount,
			keyword: this.lastSearchKeyword
		}).toString()		
	}

    get minLengthErrorMessage() {
      const lang = this.$i18n.locale
      switch(lang) {
          case 'ko':
              return '오류: 2글자 이상을 입력해야 합니다.'
          case 'en':
              return 'Error: Please enter at least 2 characters.'      
          case 'cn':
              return '错误：请输入至少2个字符。'
          case 'uz':
              return 'Xato: Kamida 2 ta belgi kiriting.'
          case 'ru':
              return 'Ошибка: Введите не менее 2 символов.'
          default:
              return 'Error: Please enter at least 2 characters.'      
      }
  }

	//
	// ──────────────────────────────────────────────── I ──────────
	//   :::::: D A T A : :  :   :    :     :        :          :
	// ──────────────────────────────────────────────────────────
	//

	keyword: string = ''
	error: string = ''
	isWithDisabled : boolean = true;

	//
	// ──────────────────────────────────────────────────────────── I ──────────
	//   :::::: L I F E C Y C L E S : :  :   :    :     :        :          :
	// ──────────────────────────────────────────────────────────────────────
	//

	created() {
		createEventBus(window, events.CANCEL_SEARCH, this.cancel)
		// this.fnComCode()
	}

	mounted() {
		this.keyword = this.lastSearchKeyword
		this.loadCompanyList();
	}

	//
	// ────────────────────────────────────────────────────── I ──────────
	//   :::::: M E T H O D S : :  :   :    :     :        :          :
	// ────────────────────────────────────────────────────────────────
	//

	loadCompanyList() {
		api.getCompanies(this.isWithDisabled).then(res => {			
			this.currentComcode = this.currentUser.comCode;
			this.companies = res.companies;
		})
	}

	onKeyup(event: KeyboardEvent) {
		console.log('onKeyup', event.key)
		event.preventDefault()
		event.stopPropagation()
		this.checkResetError((event.target as any).value)
		switch (event.key.toLowerCase()) {
			case 'enter':
				this.search()
				break

			case 'escape':
				this.cancel()
				break
		}
	}

	/**
	 * 검색을 시작합니다
	 * @param keyword 사용자가 입력한 검색어
	 */
	async search() {
		if (!this.keyword) {
			throw new Error('INVALID_OPERATION_ERROR: keyword is empty or null.')
		}
		if (this.keyword === this.lastSearchKeyword) {
			return
		}
		if (this.keyword.length < 2) {
			this.error = this.minLengthErrorMessage;
			throw new Error(
				'INVALID_OPERATION_ERROR: Keywords must be at least 2 characters long.'
			)
		}
		// this.changeViewMode('search')
		await this.beginSearch(this.keyword)

		this.reset(this.keyword)
	}

	/**
	 * 검색을 취소합니다.
	 */
	cancel() {
		// 검색 중일 경우에만 취소 가능
		if (this.viewMode === 'search') {
			// this.changeViewMode('tree')
			this.cancelSearch()
			console.log('cancel')
			const input = this.$refs['inputKeyword'] as any
			if (input) input.focus()
		}
		this.reset()
	}

	/**
	 * 검색 바 상태를 초기화합니다.
	 */
	reset(keyword: string = '') {
		this.keyword = keyword
		this.error = ''
	}

	/**
	 * Error가 표시된 경우, 상황에 따라 에러를 제거합니다.
	 * @param keyword 사용자가 입력한 키워드
	 */
	checkResetError(keyword: string) {
		if (this.error && (keyword.length == 0 || keyword.length >= 2)) {
			this.error = ''
		}
	}

	onCompanySelected(event: Event) {
		const selectedValue = (event.target as HTMLSelectElement).value;
		const changeCompany = this.companies.find(
		  (r) => r.comCode === selectedValue
		);
	  
		if (changeCompany) {		
		  this.changeComCode(this.currentComcode);		
		  this.$emit('change', event);
		} 
	}

	
}
